/**
 * KAN-746: подписи интерфейса по режиму кабинета. У сметчика сделки
 * клиента - сметы, у интернет-магазина - заказы. Разметка берёт подпись из
 * словаря и не проверяет режим сама. Новый режим = новая запись здесь.
 */
import type { OrganizationMode } from '@/types/settings';

export interface ModeLabels {
  /** KAN-987: имя режима кабинета по продукту. */
  modeName: string;
  /** Заголовок блока сделок в карточке клиента. */
  clientDealsTitle: string;
  /** Пусто в блоке сделок клиента. */
  clientDealsEmpty: string;
  /** Строка счётчика в статусе клиента; null: у режима счётчика нет (KAN-987). */
  clientDealsCount: string | null;
  /** Что удаляется вместе с клиентом: продолжение фразы "Вместе с клиентом безвозвратно ...". */
  clientDeleteWhat: string;
}

export const MODE_LABELS: Record<OrganizationMode, ModeLabels> = {
  estimator: {
    modeName: 'Услуги',
    clientDealsTitle: 'Сметы клиента',
    clientDealsEmpty: 'У этого клиента пока нет смет',
    // KAN-987: сделок у режима "Услуги" нет: ни счётчика, ни смет в удалении.
    clientDealsCount: null,
    clientDeleteWhat:
      'удаляется вся переписка с клиентом, история звонков, записи разговоров и запланированные перезвоны',
  },
  ecommerce: {
    modeName: 'Товары',
    clientDealsTitle: 'Заказы клиента',
    clientDealsEmpty: 'У этого клиента пока нет заказов',
    clientDealsCount: 'Всего заказов',
    clientDeleteWhat:
      'удаляются его заказы, история переписки и звонков, записи разговоров и запланированные перезвоны',
  },
};

/** Режим ещё не известен (настройки не загружены): подписи сметчика, как было до режимов. */
export const DEFAULT_MODE: OrganizationMode = 'estimator';

export function modeLabels(mode: OrganizationMode | undefined): ModeLabels {
  return MODE_LABELS[mode ?? DEFAULT_MODE] ?? MODE_LABELS[DEFAULT_MODE];
}
